const wowApp = require('angular').module('oly.common');

wowApp.service('ConfirmationDialogService', ['$q', require('./confirmation-dialog.service')]);

wowApp.directive('wowConfirmationDialog', ['ConfirmationDialogService', require('./confirmation-dialog.directive')]);



// WEBPACK FOOTER //
// ./src/olycommon/confirmation-dialog/index.js